import * as React from "react";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";

const VIEWS = [
  { key: "table", label: "Tabell" },
  { key: "cards", label: "Kort" },
  { key: "gantt", label: "Gantt" },
  { key: "timeline", label: "Tidslinje" },
  { key: "calendar", label: "Kalender" },
  { key: "kanban", label: "Kanban" },
];

export default function StepAddViewLayout({
  value = ["table"],
  onNext,
  onBack,
  showActions = true,
}) {
  const [views, setViews] = React.useState(new Set(value));

  // Håll parent synkad löpande
  React.useEffect(() => {
    if (onNext) onNext({ views: Array.from(views) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [views]);

  // Synka om parent skickar nytt value
  React.useEffect(() => {
    setViews(new Set(value));
  }, [value?.join("|")]);

  const toggle = (k) =>
    setViews((p) =>
      new Set(p.has(k) ? [...p].filter((x) => x !== k) : [...p, k])
    );

  const submit = () => onNext?.({ views: Array.from(views) });

  return (
    <Stack spacing={3} sx={{ p: 2 }}>
      <Typography variant="h4" fontWeight={800}>
        Lägg till vyer
      </Typography>
      <Typography color="text.secondary">
        Du kan alltid lägga till fler senare.
      </Typography>

      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        {VIEWS.map(({ key, label }) => {
          const checked = views.has(key);
          return (
            <Chip
              key={key}
              onClick={() => toggle(key)}
              color={checked ? "primary" : "default"}
              variant={checked ? "filled" : "outlined"}
              label={label}
              sx={{ px: 1.25, py: 0.5, borderRadius: 3 }}
            />
          );
        })}
      </Stack>

      {showActions && (
        <Stack direction="row" spacing={2}>
          <Button onClick={onBack}>Tillbaka</Button>
          <Button variant="contained" onClick={submit}>
            Nästa
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
